import React from "react";
import toast from "react-hot-toast";

export const Copier = ({ text, children, notify = true }) => {
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      if (notify) {
        toast.success("Copied to clipboard", {
          duration: 2000,
          removeDelay: 0,
        });
      }
    } catch (error) {
      console.error("There was a problem copying text");
      console.error(error.message);
    }
  };

  return (
    <span onClick={onClick} style={{ cursor: "pointer" }}>
      {children}
    </span>
  );
};
